import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import styles from './RapportGabarit.module.scss';
import Bouton from '../../UI/Bouton/Bouton';
import { BiArrowFromLeft, BiArrowFromRight } from 'react-icons/bi';
import ConteneurInformation from '../../ConteneurInformation/ConteneurInformation';
import * as indexConteneurInfo from '../../../ressources/glossaires/glossaire_conteneur_info';
import FormulaireRapportGabarit from './ProfilRapportGabarit/FormulaireRapportGabarit/FormulaireRapportGabarit';
import ProfilRapportGabarit from './ProfilRapportGabarit/ProfilRapportGabarit.js';
import * as actions from '../../../services/actions';
import TableauRapportGabarit from './TableauRapportGabarit/TableauRapportGabarit';

const RapportGabarit = () => {
  const dispatch = useDispatch();

  // Split state into multiple useState hooks
  const [parametresSelectione, setParametresSelectione] = useState({});
  const [montrerInfo, setMontrerInfo] = useState(false);
  const [indexConteneurInfoState, setIndexConteneurInfoState] = useState(null);
  const [montrerInfoFull, setMontrerInfoFull] = useState(false);

  // Event handlers
  const ligneSelectione = (info) => {
    setParametresSelectione(info);
    setIndexConteneurInfoState(indexConteneurInfo.profil);
    setMontrerInfo(true);
  };

  const commutateurInfoCreer = () => {
    setMontrerInfo((prev) => {
      if (!prev) {
        return true;
      }
      setMontrerInfoFull(false);
      return false;
    });
  };

  const commutateurInfoFull = () => {
    setMontrerInfoFull((prev) => !prev);
  };

  const commutateurAnnuler = () => {
    setMontrerInfo(false);
    setIndexConteneurInfoState(null);
  };

  const creer = () => {
    setMontrerInfo(true);
    setIndexConteneurInfoState(indexConteneurInfo.ajouterForm);
  };

  // Style calculations
  const styleConteneurCentralGauche = [styles.ConteneurCentralGauche];
  const styleConteneurCentralDroite = [styles.ConteneurCentralDroite];
  const commutateurClasses = [styles.CommutateurInfo];

  if (montrerInfo && montrerInfoFull) {
    styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteFull);
    styleConteneurCentralGauche.push(styles.ConteneurCentraGaucheVoid);
  } else if (montrerInfo && !montrerInfoFull) {
    styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteOuvert);
  } else {
    styleConteneurCentralDroite.push(styles.ConteneurCentralDroiteFermer);
    styleConteneurCentralGauche.push(styles.ConteneurCentraGaucheFermer);
  }

  return (
    <>
      <div className={styleConteneurCentralGauche.join(' ')}>
        <TableauRapportGabarit
          projetSelectione={ligneSelectione}
          creer={creer}
        />
      </div>
      <div className={styleConteneurCentralDroite.join(' ')}>
        <Bouton
          ajoutClass={[commutateurClasses, styles.expandTO].join(' ')}
          cliquer={commutateurInfoCreer}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromLeft size={15} />
        </Bouton>
        <Bouton
          ajoutClass={styles.expand}
          cliquer={commutateurInfoFull}
          rond={true}
          type={type_btn.danger}
        >
          <BiArrowFromRight size={15} />
        </Bouton>
        <ConteneurInformation
          selectionInfo={indexConteneurInfoState}
          ajouterForm={
            <FormulaireRapportGabarit
              ajouterAlerte={(type, titre, corps) =>
                dispatch(actions.ajouterAlerte(type, titre, corps))
              }
              annuler={commutateurAnnuler}
            />
          }
          profil={
            <ProfilRapportGabarit
              infoRapportGabarit={parametresSelectione}
              reqCreer={(data) =>
                dispatch(actions.reqCreerRapportGabarit(data))
              }
              reqSupprimer={(id) =>
                dispatch(actions.reqSupprimerRapportGabarit(id))
              }
              reqGenererRapport={(id, start, end) =>
                dispatch(actions.reqGenererRapport(id, start, end))
              }
              commutateurInfoFull={commutateurInfoFull}
            />
          }
        />
      </div>
    </>
  );
};

export default RapportGabarit;
